import React, { useMemo } from 'react';
import classes from './CategoryColorPicker.module.scss';
import { RegisterOptions, UseFormReturn } from 'react-hook-form';
import { idGenerator } from '../../../helpers/idGenerator';
import { ErrorRender } from '../../containers/ErrorRender';
import inputClasses from '../form.module.scss';
import classNames from 'classnames';
import { CategoriesColorsEnum } from '../../../constants/categories-colors';
import { ColorPicker } from '../../containers/ColorPicker';

export type CategoryColorPickerViewProps = {
  //
  disabled?: boolean;
  id?: string;
  label?: string;
  name: string;
  rules: RegisterOptions;
  useFormInstance: UseFormReturn;
  setValue: (value: string) => void;
};

export const CategoryColorPickerView = (props: CategoryColorPickerViewProps): JSX.Element => {
  const inputID = useMemo(() => props.id ?? idGenerator(props.name), [props.id, props.name]);
  const { getValues, watch } = props.useFormInstance;
  const watchSelected = watch(props.name, getValues(props.name));
  const colorPickerWrapperClasses = classNames('cell', classes.ColorPickerWrapper);

  const errorClasses = classNames(inputClasses.HelpTextErrorClass, inputClasses.HelpText);
  const colorPickers = Object.keys(CategoriesColorsEnum).map((value, index) => {
    return (
      <div className={colorPickerWrapperClasses} key={index}>
        <ColorPicker
          action={() => props.setValue(value)}
          color={CategoriesColorsEnum[value as keyof typeof CategoriesColorsEnum]}
          disabled={props.disabled}
          selected={watchSelected === value.toUpperCase()}
        />
      </div>
    );
  });
  return (
    <div className={classes.CategoryColorPicker}>
      {props.label && (
        <div className={'grid-x'}>
          <div className={'cell'}>
            <div className={inputClasses.Label}>{props.label}</div>
          </div>
        </div>
      )}
      <div className={'grid-x'}>{colorPickers}</div>
      <input id={inputID} type={'hidden'} {...props.useFormInstance.register(props.name, props.rules)} />
      <ErrorRender errors={props.useFormInstance.formState.errors} name={props.name} className={errorClasses} />
    </div>
  );
};
